/* istanbul ignore file */

export const getItemStyles = (_, { palette = {} }) => ({
  accordionItem: {
    backgroundColor: palette.white,
    boxShadow: '0px 1.6px 3.6px rgb(0 0 0 / 13%)',
    borderRadius: '2px',
    marginBottom: 12,
    padding: '24px 20px',
  },
});

export const getHeaderStyles = () => ({
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
});

export const getDetailsStyles = () => ({
  accordionDetails: {
    minHeight: 60,
    position: 'relative',
  },
  spinner: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(51, 51, 51, 0.15)',
    zIndex: 1000,
  },
});

export const getSummaryStyle = (_, { palette = {} }) => ({
  icon: {
    color: palette.redDark,
  },
  error: {
    color: palette.redDark,
  },
});
